<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-apps`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 4a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h14zm2 24a2 2 0 00-2-2H6a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V28zm22 0a2 2 0 00-2-2H28a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V28zm-26 2H8v10h10V30zm12 0h10v10H30V30zM44 6a2 2 0 00-2-2H28a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6zM18 8H8v10h10V8zm12 0h10v10H30V8z"/></svg>
</template>
<script>

export default {
  name: 'IconApps',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
